<div @progressTrigger *ngIf='inProgress'>
	<ib-icon *ngIf='prefixIcon' class='prefix' [icon]='prefixIcon'></ib-icon>
	<span *ngIf='caption'>{{caption}}</span>
	<ib-icon [icon]='spinner'></ib-icon>
</div>

